import React from 'react';
import {TextArea} from '../Common';
import { DisablesContext } from '../../constant/UserMqtt';

export default function ReceiveComponent(props: {recv: string, setRecv: any}) {
    const {recv, setRecv} = props;
    const disables = React.useContext(DisablesContext);

    return (
        <TextArea texts={recv} name={"receive message"} disabled={disables.recv} id={"receive"} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setRecv(e.target.value)}}/>
    );
}